import styled from '@emotion/styled';

const LoadingStyle = styled('div')`
    position: fixed;
    width: 100%;
    height: 100%;
    z-index: 99999;
    top: 0;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgb(255 251 244 / 60%);
`;

export default LoadingStyle;
